/* Spanish catalog mirroring locale-bank-kje09-fr.js. Keys missing here fall back to English. */
window.PlummeI18n.register('es', {
  'bank.group.toast.booked': 'El grupo de conciliación se ha contabilizado en conjunto.',
  'bank.group.err.bookUnavailable': 'El grupo de conciliación se aprobó, pero la contabilización no está disponible.',
  'bank.group.err.bookFailed': 'No se pudo contabilizar el grupo de conciliación.',
  'bank.group.book': 'Contabilizar grupo',
  'bank.resolve.reversePaymentInfo': 'La reversión anula el pago con registro de auditoría, reabre la factura del proveedor y deja la línea bancaria abierta para una nueva revisión.',
  'err.bankMatchReversalReason': 'Indica el motivo para revertir la conciliación bancaria.'
});
